import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'claims-athome-myaccount-manage-my-repair-loading',
  templateUrl: './manage-my-repair-loading.component.html',
  styleUrls: ['./manage-my-repair-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageMyRepairLoadingComponent {
  sections = Array.from({ length: 2 });
}
